import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { NovelistProps } from './constants';

export interface NovelistData {
  isSelectLoading: boolean;
  isScriptLoaded: boolean;
}

export const useNovelistSelect = ({
  isbn,
  config,
}: NovelistProps): NovelistData => {
  const [isSelectLoading, setSelectLoading] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    try {
      if (!config?.profile || !config.password || !config.url) {
        return setScriptLoaded(false);
      }

      if (!isEmpty(window.novSelect) && Boolean(isbn)) {
        return setScriptLoaded(true);
      }

      const script = document.createElement('script');
      const onScriptLoaded = () => setScriptLoaded(true);

      script.setAttribute('src', config.url);
      document.body.appendChild(script);
      script.addEventListener('load', onScriptLoaded, false);

      return () => script.removeEventListener('load', onScriptLoaded);
    } catch {
      return setScriptLoaded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isScriptLoaded && isbn) {
      setSelectLoading(true);

      try {
        window.novSelect.loadContentForQuery(
          { ClientIdentifier: isbn, ISBN: isbn, version: '2.3' },
          config?.profile as string,
          config?.password as string,
          () => setSelectLoading(false)
        );
      } catch {
        setScriptLoaded(false);
        setSelectLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScriptLoaded, isbn]);

  return { isSelectLoading, isScriptLoaded };
};
